module.exports = {
  header: {
    title: 'Potential Fraud',
  },
  setting: {
    title: 'Order notification thresholds',
    hourly: 'Hourly',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    popup: {
      hourly: 'Hourly Threshold Setting',
      daily: 'Daily Threshold Setting',
      weekly: 'Weekly Threshold Setting',
      monthly: 'Monthly Threshold Setting',
      label: '# of orders',
      confirm: 'Are you sure you want to update this threshold?',
    },
  },
  table: {
    title: {
      index: 'NO',
      orderId: 'ORDER ID',
      email: 'GOLFER EMAIL',
      firstName: 'FIRST NAME',
      lastName: 'LAST NAME',
      orderTime: 'ORDER TIME',
      orderedBySimulator: 'ORDERED BY SIMULATOR',
      ttbFingerprint: 'TTB FINGERPRINT',
      signUpIPAddress: 'SIGNUP IP ADDRESS',
      orderIPAddress: 'ORDER IP ADDRESS',
      signUpGPS: 'SIGNUP GPS',
      orderGPS: 'ORDER GPS',
      potentialFraud: 'POTENTIAL FRAUD',
      reason: 'REASON',
      gatStatus: 'GAT STATUS',
      status: 'STATUS',
      accountCreationDate: 'ACCOUNT CREATION DATE',
      productName: 'PRODUCT NAME',
      pause: 'PAUSE',
      action: 'ACTION',
    },
    body: {
      yes: 'Yes',
      no: 'No',
    },
    tooltip: {
      cancel: 'Cancel',
      note: 'Note',
      blacklist: 'Blacklist',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      blacklist: 'Blacklist this user',
      blacklistConfirm: 'Are you sure you want to blacklist this user?',
      note: 'Are you sure to note this TTB?',
      cancel: 'Are you sure to cancel this TTB?',
      confirmPassword: 'Please input your password to confirm.',
    },
  },
  form: {
    cancelReason: 'Cancel reason',
    cancelTTBFraud: 'Cancel Order Id',
    noteTTBFraud: 'Note',
    placeholderEnter: 'Enter',
    submit: 'Submit',
    add: 'Add',
    edit: 'Edit',
  },
  validate: {
    field: 'This field is not be empty!',
  },
  filter: {
    searchPlaceholder: 'Search by order ID, email, name, TTB fingerprint or order IP address',
    status: 'Status',
  },
  message: {
    orderNotFound: 'Order Not Found',
    updateSuccess: 'Potential Fraud successfully updated.',
  },
};
